import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const brandsSlider = new Swiper(".swiper-brands__blocks", {
        direction: "horizontal",
        slidesPerView: 1,
        loop: true,
        speed: 500,
        watchSlidesProgress: true,
        allowTouchMove: false,
    });

    document.querySelectorAll('.solution-slider_top .swiper-slide').forEach((slide, index) => {
        slide.addEventListener('click', () => {
            brandsSlider.slideToLoop(index, 500);
        });
    });

    const sliderConfig = {
        direction: "horizontal",
        slidesPerView: 1.2,
        slideToClickedSlide: true,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 40,
            },
        },
        speed: 500,
        watchSlidesProgress: true,
    };

    const sliderConfigWithoutClick = {
        ...sliderConfig,
    };
    delete sliderConfigWithoutClick.slideToClickedSlide;

    new Swiper(".solution-slider_top", sliderConfig);
    new Swiper(".solution-slider", sliderConfigWithoutClick);

    /*if (window.innerWidth < 1024) {
        new Swiper(".solution-slider_top", sliderConfig);

    }*/
});
